import { render, staticRenderFns } from "./AffiliatePhotosPage.vue?vue&type=template&id=b20380a2&"
import script from "./AffiliatePhotosPage.vue?vue&type=script&lang=js&"
export * from "./AffiliatePhotosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports